import Map from './map.js'
import Player from './player.js'
import colors from '../colors.js'

function World (eventBus, data) {

    this.eventBus = eventBus
    this.map      = new Map({
        startPosition: {x: data.x, y: data.y}, //only given for convenient computation of transforms
        eventBus,
        colorMap:  data.map,
        transform: data.mapTransform,
        toric:     ('toricMap' in data ? data.toricMap : true)
    })
    this.player   = new Player(eventBus, this.map.startPosition, this.map)
    initAPI(this, eventBus)

    eventBus.emit('world loaded', this)
}


World.prototype.freeze = function () {
    this.frozen = true
}


World.prototype.unfreeze = function () {
    this.frozen = false
}


World.prototype.reset = function () {
    this.unfreeze()
    this.map.reset()
    this.player.reset()
    this.eventBus.emit('world reset', this)
}


World.prototype.destroy = function () {
    this.eventBus.emit('world unloaded', this)
}


function initAPI (world) {

    world.api = {}

    for (let direction in Player.moveDirections) {
        addPlayerDirectionToApi(world, direction)
    }

    addPlayerTowardMovesToApi(world)

    world.api.again = function () {
        if (!world.frozen) {
            world.player.again()
        }
    }

    for (let color in colors) {
        addColorSensorToApi(world, color)
    }

    world.eventBus.emit('world api loaded', world.api)

}


function addColorSensorToApi (world, color) {
    world.api[color] = function () {
        return world.player.cellColor() === color
    }
}


function addPlayerDirectionToApi (world, direction) {
    world.api[direction] = function () {
        if (!world.frozen) {
            world.player.move(direction)
        }
    }
}


function addPlayerTowardMovesToApi (world) {
    world.api.movePlayerToNeighbour = function (position) {
        if (!world.frozen) {
            world.player.moveToNeighbour(position)
        }
    }
}


export default World

